import { Landmark, Layers, MessagesSquare, Sparkles } from "lucide-react";
import { Kicker, Reveal } from "./Reveal";
import { IMAGES, QUALITY_LINES, QUALITY_POINTS } from "../data/content";

const ICONS = { MessagesSquare, Sparkles, Layers, Landmark };

export const QualityPromise = () => (
  <section id="qualitaet" className="bg-white py-24 md:py-32" data-testid="quality-section">
    <div className="container-x">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <Kicker>Unser Standard</Kicker>
          </Reveal>
          <div className="mt-8">
            {QUALITY_LINES.map((line, i) => (
              <Reveal key={line} delay={0.08 + i * 0.1}>
                <p
                  data-testid={`quality-line-${i}`}
                  className={`font-display font-semibold tracking-tight leading-[1.12] text-4xl sm:text-5xl lg:text-6xl ${
                    i === 2 ? "font-fraktur !tracking-normal text-golddark" : "text-ink"
                  }`}
                >
                  {line}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
        <Reveal delay={0.15} className="lg:col-span-5">
          <figure className="relative rounded-xl border border-line overflow-hidden group" data-testid="quality-image">
            <img
              src={IMAGES.detailarbeit}
              alt="Beratungstisch bei Manfred Berglar, Malermeister: Farbfächer, Material- und Tapetenproben mit Firmenwappen"
              loading="lazy"
              className="w-full aspect-[16/9] object-cover transition-transform duration-700 group-hover:scale-[1.04]"
            />
            <figcaption className="absolute bottom-4 left-4 bg-white/90 backdrop-blur px-4 py-2.5 rounded-lg border-l-2 border-gold font-mono text-[10px] uppercase tracking-[0.18em] font-bold text-ink">
              Ehrliche Beratung, persönlich
            </figcaption>
          </figure>
        </Reveal>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-12 mt-16 md:mt-20">
        {QUALITY_POINTS.map((w, i) => {
          const Icon = ICONS[w.icon];
          return (
            <Reveal key={w.title} delay={i * 0.06} y={20}>
              <div className="border-t border-line pt-6" data-testid={`quality-point-${i}`}>
                <Icon size={22} className="text-golddark" strokeWidth={1.5} />
                <h3 className="font-display text-lg font-semibold tracking-tight text-ink mt-5">{w.title}</h3>
                <p className="text-muted leading-relaxed mt-2.5 text-sm">{w.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
